import React from 'react';

export default function OurServices() {
    // Auto-scroll removed as per user request to stop "one by one" scrolling and fix layout issues.

    return (
        <div id="our-service" className="bg-white w-full px-6 lg:px-8 pt-12 pb-12">
            <div className="max-w-[1800px] mx-auto">
                {/* Header */}
                <div className="mb-12 px-6 lg:px-8 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 lg:gap-12">
                    <div className="max-w-2xl">
                        <div className="inline-block mb-6 pt-6">
                            <span className="text-[#0054DB] font-bold tracking-tight uppercase text-lg lg:text-xl block mb-2">OUR SERVICES</span>
                            <div className="h-1 w-full bg-black rounded-full"></div>
                        </div>
                        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-[1.1] tracking-tight">
                            Unlock specialized solutions tailored for success
                        </h2>
                    </div>
                    <p className="text-gray-500 text-lg lg:text-xl leading-relaxed max-w-xl lg:text-left font-medium">
                        Our specialty services are designed to provide you with expert guidance and customized solutions that address your unique business needs.
                    </p>
                </div>
                {/* Services Grid - Responsive Layout */}
                <div
                    className="relative -mx-6 lg:-mx-8 px-6 lg:px-8 pb-12 overflow-x-auto hide-scrollbar"
                >
                    <div className="flex flex-row space-x-4 lg:space-x-0 lg:grid lg:grid-rows-2 lg:grid-flow-col lg:gap-8 w-max lg:w-fit px-6 lg:px-0">

                        {/* COLUMN 1: Development & Marketing (Wide) */}
                        <ServiceCard
                            id="development"
                            title="Development"
                            description="We build software that honors the idea and performs relentlessly. Multistack. Mobile. Database."
                            width="w-[320px] md:w-[400px] lg:w-[600px]"
                            gradient="from-[#3B82F6] to-[#2563EB]"
                            iconFull={<><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" opacity="0.5" /><path d="M12 2a10 10 0 0 1 10 10h-2a8 8 0 0 0-8-8V2z" /><path d="M2 12a10 10 0 0 1 10-10v2a8 8 0 0 0-8 8H2z" opacity="0.5" /></>}
                            graphic={
                                <div className="absolute right-[-10%] bottom-[-10%] w-[60%] h-[80%] rounded-tl-3xl bg-white/20 backdrop-blur-md border border-white/20 shadow-2xl skew-x-[-2deg] skew-y-[-2deg]">
                                    <div className="absolute top-4 left-6 flex gap-2">
                                        <div className="w-2 rounded-full bg-white/30 h-2"></div>
                                        <div className="w-2 rounded-full bg-white/30 h-2"></div>
                                        <div className="w-2 rounded-full bg-white/30 h-2"></div>
                                    </div>
                                    <div className="absolute top-3 left-20 right-6 h-5 bg-white/10 rounded-full flex items-center px-4">
                                        <span className="text-[8px] text-white/50">www.zenruva.com</span>
                                    </div>
                                    <div className="absolute top-12 left-6 right-6 bottom-6 flex flex-col gap-3">
                                        <div className="w-full h-[60%] bg-white/20 rounded-lg"></div>
                                        <div className="w-full h-2 bg-white/20 rounded-full"></div>
                                        <div className="w-[80%] h-2 bg-white/20 rounded-full"></div>
                                    </div>
                                </div>
                            }
                        />

                        <ServiceCard
                            id="automation"
                            title="Automation"
                            description="We eliminate manual effort through intelligent workflows and system automation. Efficiency at scale."
                            width="w-[320px] md:w-[400px] lg:w-[600px]"
                            gradient="from-[#3B82F6] to-[#2563EB]"
                            iconFull={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />}
                            graphic={
                                <div className="absolute right-0 top-[20%] w-[40%] flex flex-col gap-6 opacity-60">
                                    <div className="w-full h-16 bg-white/30 rounded-l-2xl transform translate-x-4"></div>
                                    <div className="w-full h-16 bg-white/30 rounded-l-2xl transform translate-x-12"></div>
                                    <div className="w-full h-16 bg-white/20 rounded-l-2xl transform translate-x-20"></div>
                                </div>
                            }
                        />

                        {/* COLUMN 2: UI/UX & Automation (Narrow) */}
                        <ServiceCard
                            id="design"
                            title="UI/UX & Design"
                            description="We craft intuitive, conversion-focused experiences grounded in user behavior & clarity."
                            width="w-[320px] md:w-[400px] lg:w-[400px]"
                            gradient="from-[#1F2937] to-[#111827]"
                            iconFull={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />}
                            graphic={
                                <div className="absolute right-[-5%] bottom-0 w-[45%] h-[90%] bg-gradient-to-b from-gray-700 to-gray-800 rounded-t-3xl border-t border-l border-white/20 p-4 shadow-2xl">
                                    <div className="flex justify-end gap-2 mb-4 opacity-50">
                                        <div className="w-6 h-1 bg-white/30 rounded-full"></div>
                                    </div>
                                    <div className="w-full aspect-video bg-white/10 rounded-lg mb-4"></div>
                                    <div className="flex gap-2 overflow-hidden">
                                        <div className="flex-1 aspect-square bg-white/10 rounded-lg"></div>
                                        <div className="flex-1 aspect-square bg-white/10 rounded-lg"></div>
                                    </div>
                                </div>
                            }
                        />

                        <ServiceCard
                            id="marketing"
                            title="Marketing"
                            description="We design growth systems, not campaigns. Data-driven strategy aligned to product, positioning, and long-term scale."
                            width="w-[320px] md:w-[400px] lg:w-[400px]"
                            gradient="from-[#1F2937] to-[#111827]"
                            iconFull={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />}
                            graphic={
                                <div className="absolute right-[-5%] bottom-[-5%] w-[60%] h-[70%]">
                                    <svg viewBox="0 0 200 200" className="w-full h-full text-white/20" fill="currentColor">
                                        <path d="M40 70 L160 70 L170 180 L30 180 Z" />
                                        <path d="M70 70 C70 40 130 40 130 70" fill="none" stroke="currentColor" strokeWidth="12" />
                                        <path d="M30 180 L170 180 L160 190 L40 190 Z" fill="black" opacity="0.1" />
                                    </svg>
                                </div>
                            }
                        />

                        {/* COLUMN 3: Launch Strategy (Tall) */}
                        <ServiceCard
                            id="launch"
                            title="Launch Strategy"
                            description="We plan and execute launches with precision—timing, messaging, and rollout aligned. No guesswork, no delays, just momentum from day one."
                            width="w-[320px] md:w-[400px] lg:w-[450px]"
                            height="h-[360px] lg:h-full lg:row-span-2"
                            gradient="from-[#1F2937] to-[#111827]"
                            iconFull={<><circle cx="12" cy="12" r="10" strokeWidth="2" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></>}
                            graphic={
                                <div className="absolute left-[10%] right-[10%] bottom-[-10%] h-[50%] bg-gradient-to-b from-gray-700 to-gray-800 rounded-t-3xl border-t border-l border-r border-white/20 p-6 shadow-2xl">
                                    <div className="w-full h-8 flex gap-2 mb-4">
                                        <div className="w-2 rounded-full bg-white/20 h-2"></div>
                                        <div className="w-2 rounded-full bg-white/20 h-2"></div>
                                        <div className="w-2 rounded-full bg-white/20 h-2"></div>
                                    </div>
                                    <div className="w-full h-full bg-white/10 rounded-lg border border-white/10 p-4">
                                        <div className="w-full h-32 bg-white/10 rounded mb-4"></div>
                                        <div className="w-full h-2 bg-white/20 rounded mb-2"></div>
                                        <div className="w-[80%] h-2 bg-white/20 rounded mb-2"></div>
                                    </div>
                                </div>
                            }
                        />

                        {/* COLUMN 4: Payments & Support (Wide) */}
                        <ServiceCard
                            id="payments"
                            title="Payments"
                            description="We implement secure, scalable payment systems built for global transactions. Optimized for reliability."
                            width="w-[320px] md:w-[400px] lg:w-[600px]"
                            gradient="from-[#3B82F6] to-[#2563EB]"
                            iconFull={<><rect x="2" y="5" width="20" height="14" rx="2" strokeWidth="2" /><line x1="2" y1="10" x2="22" y2="10" strokeWidth="2" /></>}
                            graphic={
                                <div className="absolute right-[-10%] bottom-[-10%] w-[80%] h-[60%] bg-white/20 backdrop-blur-md rounded-tl-[40px] p-6">
                                    <div className="w-16 h-10 bg-white/30 rounded-md mb-6"></div>
                                    <div className="w-full h-2 bg-white/30 rounded mb-4"></div>
                                    <div className="w-[60%] h-2 bg-white/30 rounded"></div>
                                </div>
                            }
                        />

                        <ServiceCard
                            id="support"
                            title="Support Systems"
                            description="We build operational support frameworks that scale with your business. From monitoring to workflows."
                            width="w-[320px] md:w-[400px] lg:w-[600px]"
                            gradient="from-[#3B82F6] to-[#2563EB]"
                            iconFull={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />}
                            graphic={
                                <div className="absolute right-[-10%] bottom-[-10%] w-[70%] h-[70%] bg-white/20 backdrop-blur-md rounded-tl-[40px] p-6 flex flex-col gap-4">
                                    <div className="w-[80%] h-8 bg-white/30 rounded-2xl rounded-tr-none self-end"></div>
                                    <div className="w-[60%] h-8 bg-white/20 rounded-2xl rounded-tl-none self-start"></div>
                                    <div className="w-[70%] h-8 bg-white/30 rounded-2xl rounded-tr-none self-end"></div>
                                </div>
                            }
                        />

                    </div>
                </div>
            </div>
        </div>
    );
}

// Reusable Service Card Component
function ServiceCard({ id, title, description, width, height = "h-[360px]", gradient, iconFull, graphic }) {
    return (
        <div id={id} className={`${width} ${height} shrink-0 bg-gradient-to-br ${gradient} rounded-[32px] p-8 lg:p-10 relative overflow-hidden group`}>
            <div className="relative z-10 flex flex-col items-start h-full max-w-lg">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm mb-5">
                    <svg className="w-7 h-7 text-white" fill={title === "Development" ? "currentColor" : "none"} stroke={title === "Development" ? "none" : "currentColor"} viewBox="0 0 24 24">
                        {iconFull}
                    </svg>
                </div>

                <h3 className="text-3xl font-semibold text-white mb-3">{title}</h3>
                <p className="text-white/90 text-base leading-relaxed mb-6 max-w-md">
                    {description}
                </p>

                <a href="#book-call" className="text-white text-base font-medium inline-flex items-center gap-2 mt-auto group-hover:gap-3 transition-all">
                    Get started
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </a>
            </div>
            {graphic}
        </div>
    );
}